module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    attrs: {
      "id": "page__luw",
      "loading": _vm.progress
    }
  }, [_c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'check'],
      "success-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1), _vm._v(" "), _c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "type",
      "id": "type",
      "label": "Тип способа оплаты",
      "required": true,
      "error": _vm.errors.first('type'),
      "data-vv-name": "type",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.luw.type),
      callback: function($$v) {
        _vm.$set(_vm.luw, "type", $$v)
      },
      expression: "luw.type"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selectd": "",
      "disabled": ""
    }
  }, [_vm._v("Не установлен")]), _vm._v(" "), _vm._l((Object.values(_vm.types)), function(type) {
    return _c('option', {
      domProps: {
        "value": type.value
      }
    }, [_vm._v(_vm._s(type.name))])
  })], 2), _vm._v(" "), _c('z-input-autocomplete', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (parseInt(_vm.luw.type) === 1),
      expression: "parseInt(luw.type) === 1"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: parseInt(_vm.luw.type) === 1
      }),
      expression: "{required: parseInt(luw.type) === 1}"
    }],
    attrs: {
      "name": "city_id",
      "id": "city_id",
      "display-property": "name",
      "property": "id",
      "return": "id",
      "label": "Город",
      "callback": _vm.getCities,
      "default": _vm.luw.city && _vm.luw.city.name ? _vm.luw.city.name : '',
      "error": _vm.errors.first('city_id'),
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.luw.city_id),
      callback: function($$v) {
        _vm.$set(_vm.luw, "city_id", $$v)
      },
      expression: "luw.city_id"
    }
  }), _vm._v(" "), _c('z-input-autocomplete', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (parseInt(_vm.luw.type) === 2),
      expression: "parseInt(luw.type) === 2"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: parseInt(_vm.luw.type) === 2
      }),
      expression: "{required: parseInt(luw.type) === 2}"
    }],
    attrs: {
      "name": "zone_id",
      "id": "zone_id",
      "display-property": "name",
      "property": "id",
      "return": "id",
      "label": "Направление",
      "callback": _vm.getZones,
      "default": _vm.luw.zone && _vm.luw.zone.name ? _vm.luw.zone.name : '',
      "error": _vm.errors.first('zone_id'),
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.luw.zone_id),
      callback: function($$v) {
        _vm.$set(_vm.luw, "zone_id", $$v)
      },
      expression: "luw.zone_id"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:0'),
      expression: "'required|min_value:0'"
    }],
    attrs: {
      "name": "min_time",
      "id": "min_time",
      "label": "Минимальное вермя (часы)",
      "type": "number",
      "error": _vm.errors.first('min_time'),
      "required": true,
      "data-vv-name": "min_time",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.luw.min_time),
      callback: function($$v) {
        _vm.$set(_vm.luw, "min_time", $$v)
      },
      expression: "luw.min_time"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:0'),
      expression: "'required|min_value:0'"
    }],
    attrs: {
      "name": "price",
      "id": "price",
      "label": "Цена за 1 час, 1 сотрудника (руб.)",
      "type": "number",
      "error": _vm.errors.first('price'),
      "required": true,
      "data-vv-name": "price",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.luw.price),
      callback: function($$v) {
        _vm.$set(_vm.luw, "price", $$v)
      },
      expression: "luw.price"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-697a85d9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/luw/Luw.vue
// module id = 1174
// module chunks = 0